// extracted by mini-css-extract-plugin
module.exports = {"fadeOutHalf":"small-loading-dots_fadeOutHalf__2gGzQ","fadeInHalf":"small-loading-dots_fadeInHalf__tc_VC"};